import { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Form, InputGroup } from "react-bootstrap";
import { Base } from "../../components/RootLayout";
import TopNavigation from "../../components/TopNavigation";
import * as Assets from "../../utils/svg_assets";
import Comment from "./comment";

const ReplyComment = (props) => {
  const { data, id, onClick = () => {}, postComment, getComment } = props;
  const params = useParams();
  const orgData = useSelector((state) => state.LoginSM.orgData);

  const [dataComment, setDataComment] = useState([]);

  const [formData, setFormData] = useState({
    id: params.id,
    text: "",
    idParent: id,
  });

  useEffect(() => {
    filterDataById(data);
  }, []);

  const filterDataById = (data) => {
    const result = data.filter((dt) => dt.id === id);
    setDataComment(result);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    postComment(formData);
    getComment(params.id).then((response) => {
      filterDataById(response.data.results);
    });
    setFormData({
      ...formData,
      text: "",
    });
  };

  return (
    <Base>
      <TopNavigation
        titlePage="Reply Comment"
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
        onClick={onClick}
      />
      <div className="container mt-2">
        <Comment data={dataComment} />
      </div>
      <div className="bottom-0 position-fixed w-100">
        <InputGroup className="border-gray rounded p-1">
          <Form.Control
            className="border-0"
            placeholder="Add Comment..."
            aria-label="Add Comment..."
            value={formData.text}
            onChange={(e) => setFormData({ ...formData, text: e.target.value })}
          />
          <div
            className="d-flex align-items-center m-2 text-primary-danger"
            style={{
              color: Object.keys(orgData).length > 0 ? orgData.theme_color : "",
            }}
            onClick={(e) => onSubmit(e)}
          >
            Post
          </div>
        </InputGroup>
      </div>
    </Base>
  );
};

const mapStateToProps = (state) => ({
  listComment: state.FeedsSM.listComment,
});

const mapDispatchToProps = (dispatch) => ({
  getComment: dispatch.FeedsSM.getComment,
  postComment: dispatch.FeedsSM.postComment,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReplyComment);
